import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { CreateLeadRequest } from "@zp-models/lead-collection-mapping";
import { Observable } from "rxjs";
import { environment } from "src/config/environment";

@Injectable({
  providedIn: "root",
})
export class ApiService {
  private baseUrl = environment.leadsApiBaseUrl;

  constructor(private http: HttpClient) {}

  createLead(payload: CreateLeadRequest): Observable<any> {
    return this.http.post(`${this.baseUrl}`, payload);
  }
}
